import React, { useEffect, useState, useCallback } from "react";
import ObjectList from "../../Common/ObjectList";
import ObjectListMobile from "../../Common/ObjectListMobile";
import http from "../../Common/RestAPIHandler";
import TenantTransferForm from "./TenantTransferForm";
import { Button, Popover, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
    button: {
      float: "right",
      margin: 10,
      borderRadius: 25,
      backgroundColor: theme.colorScheme,
      color: "white",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: theme.colorScheme,
        color: "white",
        border: "1px solid white",
      },
    },
  }));

const IncomingTenants = (props) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [tenantTransfer, setTenantTransfer] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loadData, setLoadData] = useState(false);
  const url = `tenant_transfers`;

  const tableColumns = [
    {
      id: "current_reseller_name",
      label: "FROM RESELLER",
      sortable: true,
    },
    {
      id: "reseller_name",
      label: "TO RESELLER",
      sortable: true,
    },
    {
      id: "tenant_name",
      label: "TENANT NAME",
      sortable: true,
    },
    {
      id: "tenant",
      label: "TENANT ID",
      minWidth: 300,
      sortable: false,
    },
    {
      id: "email",
      label: "EMAIL",
      sortable: true,
    },
    {
      id: "status",
      label: "STATUS",
      sortable: true,
    },
    {
      id: "action",
      label: "",
      minWidth: 200,
      sortable: true,
    },
  ];

  const fetchData = useCallback(() => {
    setLoadData(true);
    http.Get(
      url,
      (data) => {
        var transfers = [];
        data.forEach((transfer)=>{
          if(transfer.reseller === props.user.reseller && transfer.status !== "Transfered"){
            if(transfer.status === "Approved"){
              transfer["action"] = ("Transfer on 1st of next month!");
            }
            transfers.push(transfer);
          }
        });
        setData(transfers);
        setLoadData(false);
      },
      () => {}
    );
  }, [url, props.user.reseller]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
    {tenantTransfer &&      
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={()=>{setAnchorEl(null);setTenantTransfer(null);}}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
      >
        <div style={{padding:10}}>
          Enter Tenant ID To Confirm Transfer:        
          <TextField
            fullWidth
            variant="outlined"
            margin="dense"
            onChange={(e)=>{
              setTenantTransfer({
                ...tenantTransfer,
                confirm_tenant: e.target.value,
                status: "Transfered"
              })
            }}
            placeholder="Confirm Tenant ID"
          />
          <Button
            className={classes.button}
            variant="outlined"
            size="small"
            color="primary"
            onClick={(e)=>{
              http.Put(
                `tenant_transfers/${tenantTransfer.id}`,
                tenantTransfer,
                () => {
                  fetchData();
                  setAnchorEl(null);
                  setTenantTransfer(null);
                },
                (status, error) => {
                  console.log(error);
                  setAnchorEl(null);
                  setTenantTransfer(null);
                }
              );
            }}
            disabled={tenantTransfer.tenant !== tenantTransfer.confirm_tenant}
          >
            Confirm
          </Button>
        </div>
      </Popover>
    }
    {!props.mobile && 
    <ObjectList
      {...props}
      moduleName={"Incoming Tenants"}
      actions = {{
        delete: true,
        importCSV: false,
        exportCSV: false,
        exportPDF: false,
      }}
      permissions={{
        create: ['Create Incoming Transfer'],
        edit: ['Create Incoming Transfer'],
        delete: ['Create Incoming Transfer'],
      }}
      url={url}
      objectForm={TenantTransferForm}
      tableColumns={tableColumns}
      searchFields={["company_name"]}
      data={data}
      fetchData={fetchData}
      pageHeader={"Tenants"}
      loadData={loadData}
    />
    }
    {props.mobile && 
    <ObjectListMobile
      {...props}
      moduleName={"Incoming Tenants"}
      actions = {{
        delete: true,
        importCSV: false,
        exportCSV: false,
        exportPDF: false,
      }}
      permissions={{
        create: ['Create Incoming Transfer'],
        edit: ['Create Incoming Transfer'],
        delete: ['Create Incoming Transfer'],
      }}
      url={url}
      objectForm={TenantTransferForm}
      tableColumns={tableColumns}
      searchFields={["company_name"]}
      data={data}
      fetchData={fetchData}
      pageHeader={"Tenants"}
      loadData={loadData}
    />
    }
    </>
  );
};

export default IncomingTenants;
